import httpClient, {
  getErrorMessage,
  getResponseData,
} from 'lib/httpClient';
import { Catalogue } from './types';

const url = 'catalogues';

export const getCatalogueByIdOrSlug = async (
  idOrSlug: string | number,
): Promise<Catalogue> => {
  try {
    const response = await httpClient.get(
      `${url}/${idOrSlug.toString()}`,
    );

    return getResponseData(response).data;
  } catch (err) {
    throw getErrorMessage(err);
  }
};
